export default "__VITE_ASSET__DgZ$px9D__"